import React, { useState } from 'react';
import Navbar from '../components/Navbar.jsx';
import Footer from '../components/Footer.jsx';
import Seo from '../components/Seo.jsx';

const GALLERY = [
  { id: 1,  src: "/Assets/IMG_2048.jpg" },
  { id: 2,  src: "/Assets/IMG_2490 (1).jpg" },
  { id: 3,  src: "/Assets/IMG_9897 (1).jpg" },
  { id: 4,  src: "/Assets/IMG_2066.jpg" },
  { id: 5,  src: "/Assets/IMG_2457.jpg" },
  { id: 6,  src: "/Assets/IMG_1312 (1).jpg" },
  { id: 7,  src: "/Assets/03f8d6d2-4f7e-4c97-9992-f9880a8353e9-copied-media~2.jpg" },
  { id: 8,  src: "/Assets/About us assets/1J2A5779.jpg" },
  { id: 9,  src: "/Assets/News image.jpg" },
  { id: 10, src: "/Assets/Contact Us.jpg" },
];

// Explicit placements on a 3-column × auto-row grid (300px rows)
const PLACEMENTS = [
  { gridColumn: "1 / 3", gridRow: "1 / 3" },   // 2w 2t — hero feature
  { gridColumn: "3 / 4", gridRow: "1 / 3" },   // 1w 2t
  { gridColumn: "1 / 2", gridRow: "3 / 4" },
  { gridColumn: "2 / 3", gridRow: "3 / 4" },
  { gridColumn: "3 / 4", gridRow: "3 / 5" },   // 1w 2t
  { gridColumn: "1 / 3", gridRow: "4 / 5" },   // 2w 1t
  { gridColumn: "1 / 2", gridRow: "5 / 6" },
  { gridColumn: "2 / 3", gridRow: "5 / 6" },
  { gridColumn: "1 / 2", gridRow: "6 / 7" },
  { gridColumn: "2 / 4", gridRow: "6 / 7" },   // 2w 1t
];

export default function Gallery() {
  const [hovered,  setHovered]  = useState(null);
  const [lightbox, setLightbox] = useState(null);

  return (
    <div style={{ background: '#0A0A0A', minHeight: '100vh', fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif" }}>
      <Seo title="Gallery" description="Photos from Drunken Lectures — the stage, the crowd, and the after-hours." path="/gallery" />
      <Navbar />

      {/* ── HERO ── */}
      <section style={{
        position: 'relative',
        height: '52vh',
        minHeight: '340px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',
        padding: '0 clamp(1.25rem, 4vw, 2.5rem) 3rem',
        overflow: 'hidden',
      }}>
        <img
          src="/Assets/IMG_2048.jpg"
          alt=""
          aria-hidden="true"
          style={{
            position: 'absolute', inset: 0,
            width: '100%', height: '100%',
            objectFit: 'cover', objectPosition: 'center',
            filter: 'blur(2px) brightness(0.28)',
            transform: 'scale(1.04)',
          }}
        />

        <div className="dl-grain" style={{ position: 'absolute', inset: 0, zIndex: 1, pointerEvents: 'none' }} />

        <div style={{ position: 'relative', zIndex: 2, maxWidth: '1400px', width: '100%' }}>
          <p style={{ color: '#E8672E', fontSize: '0.7rem', fontWeight: '700', letterSpacing: '0.2em', margin: '0 0 0.75rem' }}>
            DRUNKEN LECTURES
          </p>
          <h1 style={{
            color: '#FFFFFF',
            fontFamily: "-apple-system, BlinkMacSystemFont, 'SF Pro Display', 'Helvetica Neue', Arial, sans-serif",
            fontSize: 'clamp(3rem, 8vw, 7rem)',
            fontWeight: '600',
            letterSpacing: '-0.02em',
            lineHeight: 0.9,
            margin: '0 0 1.25rem',
          }}>
            GALLERY
          </h1>
          <p style={{ color: 'rgba(255,255,255,0.45)', fontSize: '0.85rem', fontWeight: '500', letterSpacing: '0.15em', margin: 0 }}>
            EVERY LECTURE LEAVES A MARK
          </p>
        </div>
      </section>

      {/* ── GRID ── */}
      <main style={{ padding: '3px', maxWidth: '1400px', margin: '0 auto' }}>
        <div className="gallery-grid" style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(3, 1fr)',
          gridAutoRows: '300px',
          gap: '3px',
        }}>
          {GALLERY.map((item, i) => {
            const isHov = hovered === item.id;
            const place = PLACEMENTS[i] ?? {};

            return (
              <div
                key={item.id}
                style={{
                  ...place,
                  position: 'relative',
                  overflow: 'hidden',
                  cursor: 'pointer',
                }}
                onMouseEnter={() => setHovered(item.id)}
                onMouseLeave={() => setHovered(null)}
                onClick={() => setLightbox(item)}
              >
                <img
                  src={item.src}
                  alt=""
                  loading="lazy"
                  style={{
                    width: '100%', height: '100%',
                    objectFit: 'cover',
                    transform: isHov ? 'scale(1.06)' : 'scale(1)',
                    transition: 'transform 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
                    display: 'block',
                  }}
                />

                {/* hover vignette */}
                <div style={{
                  position: 'absolute', inset: 0,
                  background: 'rgba(232, 103, 46,0.12)',
                  opacity: isHov ? 1 : 0,
                  transition: 'opacity 0.35s ease',
                  pointerEvents: 'none',
                }} />
              </div>
            );
          })}
        </div>
      </main>

      {/* ── LIGHTBOX ── */}
      {lightbox && (
        <div
          role="dialog"
          aria-modal="true"
          style={{
            position: 'fixed', inset: 0, zIndex: 9000,
            background: 'rgba(0,0,0,0.93)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            padding: '2rem',
            animation: 'lbFadeIn 0.22s ease',
          }}
          onClick={() => setLightbox(null)}
        >
          <div style={{ position: 'relative' }} onClick={e => e.stopPropagation()}>
            <img
              loading="lazy"
              decoding="async"
              src={lightbox.src}
              alt=""
              style={{
                maxWidth: '90vw',
                maxHeight: '90vh',
                objectFit: 'contain',
                display: 'block',
                borderRadius: '4px',
              }}
            />
            <button
              onClick={() => setLightbox(null)}
              style={{
                position: 'absolute', top: '-1rem', right: '-1rem',
                background: '#E8672E', border: 'none', borderRadius: '50%',
                width: '36px', height: '36px', cursor: 'pointer',
                color: '#fff', fontSize: '1.1rem', fontWeight: '700',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
              }}
              aria-label="Close"
            >
              ×
            </button>
          </div>
        </div>
      )}

      <div style={{ marginTop: '6rem' }}>
        <Footer />
      </div>

      <style>{`
        .dl-grain {
          background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)' opacity='0.4'/%3E%3C/svg%3E");
          background-repeat: repeat;
          background-size: 128px 128px;
          opacity: 0.04;
          mix-blend-mode: overlay;
        }
        @keyframes lbFadeIn { from { opacity: 0; } to { opacity: 1; } }
        * { box-sizing: border-box; }
        @media (max-width: 768px) {
          .gallery-grid { grid-template-columns: repeat(2, 1fr) !important; grid-auto-rows: 220px !important; }
          .gallery-grid > div { grid-column: auto !important; grid-row: auto !important; }
        }
        @media (max-width: 480px) {
          .gallery-grid { grid-template-columns: 1fr !important; grid-auto-rows: 260px !important; }
        }
      `}</style>
    </div>
  );
}
